import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import "../style/Personalizzami.css";

const Personalizzami = (props) => {
  return (
    <div className="card_personalizzami">
      <div className="titolo_personalizzami">{props.card.nome}</div>

      <img
        className="image_personalizzami"
        src={props.card.path}
        alt="BigCo Inc. logo"
      />

      <div className="conenitore-info-personalizzami">
        <div className="pulsanti-personalizzami">
          <a
            href="#fakeLink"
            onClick={() =>
              props.prepara(props.card.id_prodotto, props.id_prodotto_interno)
            }
            className="btn purple"
          >
            Iniziamo
          </a>
        </div>
      </div>
    </div>
  );
};

export default Personalizzami;
